import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { en } from 'i18n/langs/en'

export default {
  async setup() {
    await i18n.use(initReactI18next).init({
      resources: { en },

      lng: 'en',
      fallbackLng: 'en',

      interpolation: {
        escapeValue: false,
      },
    })
  },
}
